import React from "react";

// Reusable Card Component for Experience and Education
const Card = ({
  title,
  subtitle,
  image,
  duration,
  status,
  statusColor = "bg-green-200 text-green-600",
}) => (
  <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg p-4">
    <h4 className="text-xl font-semibold text-gray-900 dark:text-white flex items-center gap-2">
      {image && <img src={image} alt={`${title} logo`} className="inline w-10" loading="lazy" width="40" height="40" />}
      {title}
    </h4>
    <p className="text-sm text-gray-600 dark:text-gray-400">{subtitle}</p>
    <div className="flex justify-between items-center mt-2">
      <span className="text-sm text-gray-500 dark:text-gray-400">
        {duration}
      </span>
      <span className={`${statusColor} text-xs font-bold py-1 px-2 rounded`}>
        {status}
      </span>
    </div>
  </div>
);

function About({ aboutDescription, experiences = [], education = [] }) {

  return (
    <section className="py-12">
      {/* About Me Section */}
      <div className="mb-8 text-left">
        <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
          About Me
        </h2>
        <p className="mt-4 text-gray-700 dark:text-gray-300 max-w-2xl">
          {aboutDescription || "The Generator App is an online tool that helps you export ready-made templates for your future website. It allows you to combine slides, panels, and other components, exporting them as static HTML/CSS/JS files."}
        </p>
      </div>

      {/* Work Experience Section */}
      <div className="mb-12">
        <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
          Work Experience
        </h3>
        <div className="mt-6 space-y-4">
          {experiences.map((exp, index) => (
            <Card
              key={index}
              title={exp.title}
              subtitle={`${exp.company} - ${exp.location}`}
              image={exp.companyLogo}
              duration={`${exp.startDate} - ${exp.endDate}${
                exp.endDate !== "Present"
                  ? ` · ${calculateDuration(exp.startDate, exp.endDate)}`
                  : ""
              }`}
              status={exp.status}
            />
          ))}
        </div>
      </div>

      {/* Education Section */}
      <div>
        <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
          Education
        </h3>
        <div className="mt-6 space-y-4">
          {education.map((edu, index) => (
            <Card
              key={index}
              title={edu.institution}
              subtitle={edu.location}
              image={edu.institutionLogo}
              duration={`${edu.startDate} - ${edu.endDate}`}
              status={edu.status}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

// Helper function to calculate duration (simplified)
const calculateDuration = (startDate, endDate) => {
  // This is a simplified version - you can enhance it with proper date parsing
  return "";
};

export default About;
